import { Avatar } from '@dtx-company/design-system/src/components/Avatar/Avatar'
import { Box } from '@dtx-company/design-system/src/components/Box/Box'
import { EntityTypes } from '@dtx-company/inter-app/src/redux/slices/modal'
import { FC } from 'react'
import { TruncatedText } from '@dtx-company/inter-app/src/components/TruncatedText'
import { Typography } from '@dtx-company/design-system/src/components/Typography/Typography'
import { getEntityAvatarName } from '@dtx-company/inter-app/src/components/org/utils/getEntityAvatarName'
import { setNavLeftMenu } from '@dtx-company/inter-app/src/redux/slices/config-slice'
import { theme } from '@dtx-company/design-system/src/theme/'
import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import { useDispatch } from 'react-redux'
import { useMediaQuery } from '@mui/material'
import { useProfilePicture } from '@app/common/src/hooks/useProfilePicture'
import { useProfilePictureModal } from '@dtx-company/inter-app/src/hooks/useProfilePictureModal'
import CameraAltIcon from '@mui/icons-material/CameraAlt'
import IconButton from '@mui/material/IconButton'

export const ProfileImageUpload: FC = () => {
  const { setOpen } = useProfilePictureModal()
  const dispatch = useDispatch()
  const { jwt } = useAuthState()

  const profilePicture = useProfilePicture({
    entityId: jwt?.ithacaId,
    entityType: EntityTypes.USER,
    token: jwt?.token
  })
  const isMobile = useMediaQuery(`(max-width:${theme.breakpoints.values.md}px)`)

  const fullName = getEntityAvatarName({
    firstName: jwt?.firstName,
    lastName: jwt?.lastName,
    email: jwt?.email
  })
  return (
    <Box
      sx={theme => ({
        display: 'flex',
        alignItems: 'center',
        padding: 2,
        [theme.breakpoints.up('md')]: {
          flexDirection: 'column'
        }
      })}
    >
      <Box
        sx={theme => ({
          background: 'transparent',
          border: 'none',
          position: 'relative',
          marginBottom: 1.5,
          [theme.breakpoints.down('md')]: {
            marginRight: 1.5,
            marginBottom: 0
          }
        })}
        data-testid="edit-profile-image"
        onClick={() => {
          setOpen({
            entityId: jwt?.ithacaId || '',
            entityType: EntityTypes.USER,
            profilePicture: profilePicture || '',
            entityName: fullName
          })
          if (isMobile) {
            dispatch(setNavLeftMenu({ open: false }))
          }
        }}
      >
        <Avatar size="medium" alt={fullName} src={profilePicture} />
        <IconButton
          sx={theme => ({
            position: 'absolute',
            bottom: -8,
            right: -8,
            padding: 0.25,
            backgroundColor: theme.palette.background.paper,
            ':hover': {
              backgroundColor: theme.palette.background.paper
            }
          })}
        >
          <CameraAltIcon fontSize="small" htmlColor="#000" />
        </IconButton>
      </Box>
      <Box
        sx={theme => ({
          display: 'flex',
          flexDirection: 'column',
          marginLeft: 1,
          [theme.breakpoints.up('md')]: {
            alignItems: 'center',
            marginLeft: 0
          },
          fontSize: '1.25rem',
          maxWidth: '240px'
        })}
      >
        <TruncatedText textAlign={{ _: 'left', md: 'center' }} lineHeight="1.5rem" fontWeight={600}>
          {fullName}
        </TruncatedText>
        {jwt?.email !== fullName && <Typography variant="bodySmall">{jwt?.email}</Typography>}
      </Box>
    </Box>
  )
}
